import { CloseOutlined, DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons"
import { Modal } from "antd"
import { useEffect, useState } from "react"

import useToast from "../../../../hook/useToast"
import { deleteCarColorGroup, editColorCarGroup, getListCarColorGroup, gInforColorCarGroup, ICarColorGroup } from "../../../../api/colorCar/colorCarApi"
import ModalEditGroupColorCar from "./ModalEditGroupColorCar"
import ModalDeleteManager from "../../../../components/ModalDeleteManager"
import ModalAddGroupColorCar from "./ModalAddGroupColor"
import { IRelative } from "../../../../api/selectOptions/selectOptionsApi"
interface ModalProps {
  isOpen: boolean
  listGroupColor: IRelative[]
  gListCarColorGroup: () => void
  closeModal: () => void
}

const ModalManagerGroupColor: React.FC<ModalProps> = ({
  isOpen, listGroupColor,
  closeModal, gListCarColorGroup
}) => {

  useEffect(() => {

    return (() => {

    })
  }, [])

  const pushToast = useToast()

  const [isOpenAddGroupColor, setIsOpenAddGroupColor] = useState(false)
  const [opentEditGroupColor, setOpenEditGroupColor] = useState(false)
  const [opentDeleteGroupColor, setOpenDeleteGroupColor] = useState(false)

  const [infoGroupColor, setinfoGroupColor] = useState<ICarColorGroup>()
  const [idColor, setIdColor] = useState<number>()


  const gInfoCarColorGroup = async (id: number) => {
    const result = await gInforColorCarGroup(id);

    if (result?.status) {
      setOpenEditGroupColor(true)
      setinfoGroupColor(result.data)
    } else {
      pushToast(result?.message, "warning")
    }
  }
  const onSubmitFormModalAdd = (iSsuccess: boolean, errorMessage?: string) => {
    if (iSsuccess) {
      setIsOpenAddGroupColor(false);
      pushToast(errorMessage, "success")
      gListCarColorGroup()
    }
    else {
      pushToast(errorMessage, "warning")
    }
  }
  const onSubmitFormModalEdit = (iSsuccess: boolean, errorMessage?: string) => {
    if (iSsuccess) {
      setOpenEditGroupColor(false);
      pushToast(errorMessage, "success")
      gListCarColorGroup()
    }
    else {
      pushToast(errorMessage, "warning")
    }
  }

  const handleOpenDeleteGroupColor = (id: number) => {
    setIdColor(id)
    setOpenDeleteGroupColor(true)
  }

  const closeModalDeleteGroupColor = () => {
    setIdColor(undefined)
    setOpenDeleteGroupColor(false)
  }

  const onConfirmDelete = async () => {
    const result = await deleteCarColorGroup(Number(idColor))
    if (result?.status) {
      setOpenDeleteGroupColor(false)
      setIdColor(undefined)
      pushToast(result?.message, "success")

      gListCarColorGroup()
    } else {
      pushToast(result?.message, "warning")
    }
  }
  useEffect(() => {
    if (isOpen) {
      gListCarColorGroup()
    }
  }, [isOpen])
  return (
    <div>
      <ModalAddGroupColorCar
        isOpen={isOpenAddGroupColor}

        onSubmitFormModalAdd={onSubmitFormModalAdd}
        closeModal={() => setIsOpenAddGroupColor(false)}
      />
      <ModalEditGroupColorCar
        isOpen={opentEditGroupColor}
        infoGroupColor={infoGroupColor}
        onSubmitFormModalEdit={onSubmitFormModalEdit}
        closeModal={() => setOpenEditGroupColor(false)}
      />
      <ModalDeleteManager
        isOpen={opentDeleteGroupColor}
        closeModal={closeModalDeleteGroupColor}
        title='Bạn có chắc chắn xóa nhóm màu xe này'
        titleDelete='Xóa nhóm màu xe'
        content='Nhóm màu xe và dữ liệu liên quan sẽ bị xóa vĩnh viễn không thể khôi phục'
        onConfirm={onConfirmDelete}
      />



      <Modal
        title={<div className="bg-FCFCFD d-flex justify-betweeen align-center py-4 px-6 w-full border-b-F0F0F0">
          <span className="text-base text-344054 fw-500 font-medium">Quản lý nhóm màu xe</span>
          <CloseOutlined className="text-base text-8B8B8B"
            onClick={closeModal}
          />
        </div>}
        onCancel={closeModal}
        open={isOpen}
        centered
        className="w-modal modal-content ant-modal-size m-none-header"
        closeIcon={false}
        footer={[]}
      >
        <div className="h-355-px overflow-y-scroll">
          <div className="d-flex align-center gap-18-px pl-6 py-3 bg-FAFAFA border-bottom-EEEEEE">
            <p className="text-base text-4B4B4B fw-500 font-medium">Thuộc tính</p>
            <div className="d-flex align-center rounded-2 h-26-px w-62-px gap-1 border-096DD9 justify-center cursor-pointer"
              onClick={() => setIsOpenAddGroupColor(true)}
            >
              <p className="text-xs text-096DD9 font-regular">Thêm</p>
              <PlusOutlined className="text-xs text-096DD9 " />
            </div>
          </div>
          <div className="d-flex flex-column">
            {listGroupColor.map((item, index) => (
              <div className="d-flex justify-between w-full border-bottom-EEEEEE" key={index}>
                <div className=' d-flex align-center justify-between pl-6  py-18-px gap-2  h-fit-content bg-white'
                >
                  <p className='text-base font-regular  text-344054'>{item.title}</p>
                </div>
                <div className="d-flex align-center gap-6 pr-6">
                  <EditOutlined
                    className="text-base text-096DD9 cursor-pointer"
                    onClick={() => gInfoCarColorGroup(item.id)}
                  />
                  <DeleteOutlined
                    className="text-base text-F5222D cursor-pointer"
                    onClick={() => handleOpenDeleteGroupColor(item.id)}
                  />
                </div>
              </div>
            ))}

          </div>
        </div>


      </Modal>
    </div>

  )
}
export default ModalManagerGroupColor

